export default __webpack_public_path__ + "static/media/listview.fe5b8b62.svg";